import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        bannerOuterContainer: {
            background: 'background.brand',
            color: 'text.inverse',
            marginX: 'auto',
            maxWidth: remCalc(1654),
            maxHeight: {base: remCalc(428), lg: remCalc(348)},
        },
        bannerInnerContainer: {
            flexDirection: {base: 'column', lg: 'row'},
            padding: {base: remCalc(16), lg: remCalc(0)},
            gap: remCalc(24),
            w: '100%',
            justifyContent: 'space-between',
        },
        bannerTextStack: {
            flexDirection: 'column',
            textAlign: {base: 'center', lg: 'start'},
            alignItems: {base: 'center', lg: 'flex-start'},
            justifyContent: 'center',
            gap: {base: remCalc(8), lg: remCalc(24)},
            paddingLeft: {base: remCalc(0), lg: remCalc(40)},
            paddingY: {base: remCalc(0), lg: remCalc(104)},
        },
        bannerTitle: {
            textStyle: 'head-medium',
            fontWeight: 'medium',
        },
        bannerDescription: {
            textStyle: 'body-medium',
            fontWeight: 'normal',
        },
        bannerButton: {
            w: remCalc(214),
            h: remCalc(40),
            textDecoration: 'none !important',
        },
        bannerImage: {
            w: {base: '100%', lg: remCalc(569)},
            h: {base: remCalc(210), lg: '100%'},
            objectFit: 'cover',
            order: {base: 0, lg: 1},
            alignSelf: {base: 'flex-start', lg: 'flex-end'},
            mx: {base: 'auto', lg: remCalc(0)},
        },
    },
}
